import { render } from "./MarketAnalyze.vue?vue&type=template&id=07bef1f6&scoped=true"
import script from "./MarketAnalyze.vue?vue&type=script&lang=js"
export * from "./MarketAnalyze.vue?vue&type=script&lang=js"

import "./MarketAnalyze.vue?vue&type=style&index=0&id=07bef1f6&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\meta-buysell.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07bef1f6"]])

export default __exports__